import { Pipe, PipeTransform } from '@angular/core';
import { ThemePalette } from '@angular/material/core';

@Pipe({
  name: 'themeColor',
  standalone: false,
})
export class ThemeColorPipe implements PipeTransform {
  transform(value: ThemePalette): string {
    return `var(--mat-${value})`;
  }
}
